// NPM Imports
// Quote Context
// Component Imports
// JS Imports
// Asset Imports

// Variables
const referrer = document.referrer

export default function UnauthorizedScreen() {
   if (
      referrer.includes('force.com') ||
      referrer.includes('quote.bamboohr.net') ||
      referrer.includes('stage.quote.bamboohr.net')
   )
      return (
         <div>
            <div className='fs-2 h-100 d-flex align-items-center justify-content-center'>
               🚫 Unauthorized
            </div>
            <div className='fs-5 h-100 d-flex align-items-center justify-content-center'>
               If coming from Salesforce please refresh your webpage. If the
               error persists, please &nbsp;
               <a
                  target='_blank'
                  href='https://bamboohr.atlassian.net/servicedesk/customer/portal/9'
               >
                  submit a ticket.
               </a>
            </div>
         </div>
      )
   else
      return (
         <div className='fs-2 h-100 d-flex align-items-center justify-content-center'>
            🚫 Unauthorized
         </div>
      )
}
